import { Trans } from '@lingui/react/macro';

import type { ShiftSet } from '@/types/template';

import { PatternStarterChoices } from './pattern-starters';

interface PatternEmptyStateProps {
  /**
   * Begins a new pattern: with a pre-filled starter skeleton, or `null` to
   * start from scratch. The shift type is always left empty so the user picks
   * a real one (starter names are display sugar, not resolved type IDs).
   */
  onStart: (pattern: ShiftSet | null) => void;
  /** Opens the bulk Excel import. */
  onImport: () => void;
}

/**
 * Empty left pane: a heading plus the {@link PatternStarterChoices} (starter
 * cards + start-from-scratch + import). The same choices appear in the "Add
 * pattern" modal once the template already has patterns.
 */
export function PatternEmptyState({ onStart, onImport }: PatternEmptyStateProps) {
  return (
    <div className="flex flex-col gap-4 p-6 text-center">
      <div>
        <p className="text-sm font-medium">
          <Trans>No shift patterns yet</Trans>
        </p>
        <p className="text-xs text-muted-foreground">
          <Trans>Start from a common pattern or build your own.</Trans>
        </p>
      </div>

      <PatternStarterChoices onStart={onStart} onImport={onImport} />
    </div>
  );
}
